import { useStore } from "../StateProvider";

const Journal = ({
  className = { field: "", lable: "", input: "" },
  name = "",
  label = "",
  doubleline = false,
  onchange = () => {},
}) => {
  const store = useStore();
  let props = store.getprops(name) || {};

  if (!props.hidden) {
    return (
      <div
        className={
          (className.field === ""
            ? "flex text-[12px] md:text-[14px] w-full h-full gap-3 px-3 "
            : className.field) +
          (doubleline ? "flex-col " : "flex-row items-center")
        }
      >
        <label
          className={
            className.lable === ""
              ? "w-fit  min-w-[150px] max-w-full"
              : className.lable
          }
          onClick={() => {
            document.getElementById(name).focus();
          }}
        >
          {label}
          {props.mandatory && (
            <span className="text-[#ff2828] text-[14px] h-fit">*</span>
          )}
        </label>
        <textarea
          className={
            (className.input === ""
              ? "w-full border rounded-lg px-2 h-10 md:h-20 disabled:bg-[#f2f2f2] disabled:text-[#4d4d4e]"
              : className.input) +
            (props.mandatory && props.show
              ? "rounded-2xl border-2 border-[#ff2828] "
              : "")
          }
          id={name}
          value={store.getvalue(name)}
          disabled={props.readonly}
          onChange={(event) => {
            store.setvalue(name, event.target.value);
            onchange(event.target.value);
          }}
        />
      </div>
    );
  }
};

export default Journal;
